import { Component, Vue } from 'vue-facing-decorator';
import { Delete, EditPen, UserFilled, Ticket, Opportunity, Failed, Lock } from '@element-plus/icons-vue';
import AuthService from '@/services/AuthService';

@Component(
{
    props:
    {
        model:
        {
            type: Object,
            required: true
        }
    },
    components:
    {
		EditPen,
		Delete,
        UserFilled,
        Ticket,
        Opportunity,
        Failed,
        Lock
    },
    emits:
    [
        'onTestEdit',
        'onTestDelete'
    ]
})

export default class TestItem extends Vue 
{
    private hasPermission: boolean[] = [] as boolean[];

    public async mounted()
    {
        // get permissions
        this.hasPermission['TEST_SELECT'] = AuthService.hasPermission('TEST_SELECT');
        this.hasPermission['TEST_INSERT'] = AuthService.hasPermission('TEST_INSERT');
        this.hasPermission['TEST_UPDATE'] = AuthService.hasPermission('TEST_UPDATE');
        this.hasPermission['TEST_DELETE'] = AuthService.hasPermission('TEST_DELETE');
        this.hasPermission['TEST_QUESTION'] = AuthService.hasPermission('TEST_QUESTION');
    }

    private onTestEditClick()
    {
        this.$emit('onTestEdit', this.model);
    }

    private onTestDeleteClick()
    {
        this.$emit('onTestDelete', this.model);
    }
}

